document.addEventListener("DOMContentLoaded", function() {
  const addToCartButton = document.querySelector('.product-form__submit');
  if (!addToCartButton) return;
  addToCartButton.addEventListener('click', function(event) {
    const productTags = document.querySelector('[data-product-tags]');
    if (productTags && productTags.innerHTML.includes('pre-order')) {
      event.preventDefault();
      alert('This is a pre-order item. Estimated shipping: 2-3 weeks.');
      setTimeout(() => {
        addToCartButton.closest('form').submit();
      }, 500);
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const popupOverlay = document.createElement("div");
  popupOverlay.id = "popupModal";
  popupOverlay.style.display = "none";
  popupOverlay.style.position = "fixed";
  popupOverlay.style.top = "0";
  popupOverlay.style.left = "0";
  popupOverlay.style.width = "100%";
  popupOverlay.style.height = "100%";
  popupOverlay.style.background = "rgba(0, 0, 0, 0.5)";
  popupOverlay.style.zIndex = "1000";
  popupOverlay.style.justifyContent = "center";
  popupOverlay.style.alignItems = "center";

  const popupContent = document.createElement("div");
  popupContent.style.background = "#1c1c1c";
  popupContent.style.padding = "20px";
  popupContent.style.borderRadius = "8px";
  popupContent.style.width = "90%";
  popupContent.style.maxWidth = "600px";
  popupContent.style.position = "relative";

  const closeButton = document.createElement("span");
  closeButton.innerHTML = "&times;";
  closeButton.style.position = "absolute";
  closeButton.style.top = "10px";
  closeButton.style.right = "15px";
  closeButton.style.fontSize = "24px";
  closeButton.style.color = "#fff";
  closeButton.style.cursor = "pointer";

  popupContent.appendChild(closeButton);

  const formContainer = document.getElementById("preorderpopup2");
  if (formContainer) {
    popupContent.appendChild(formContainer);
  }

  popupOverlay.appendChild(popupContent);
  document.body.appendChild(popupOverlay);

  function openPopup() {
    popupOverlay.style.display = "flex";
  }

  function closePopup() {
    popupOverlay.style.display = "none";
  }

  closeButton.addEventListener("click", closePopup);
  popupOverlay.addEventListener("click", function (event) {
    if (event.target === popupOverlay) {
      closePopup();
    }
  });

  // Attach openPopup to all elements with class .pre-order-button or .pre-order-button1
  const preOrderButtons = document.querySelectorAll(".pre-order-button, .pre-order-button1");
  preOrderButtons.forEach(button => {
    button.addEventListener("click", openPopup);
  });
});

